import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import About from "../pages/about";
import Contact from "../pages/contact";
import Home from "../pages/home";
import Checkout from "../pages/order/chechout";
import ProfileInfo from "../pages/profile/profileInfo";
import Addresses from "../pages/profile/addresses";
import Orders from "../pages/profile/orders";
import Wallet from "../pages/profile/wallet";
import SignIn from "../pages/profile/signIn";
import SignUp from "../pages/profile/signUp";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/store";
import ForgetSubCode from "../pages/profile/forgetSubCode";
import { Toaster } from "react-hot-toast";
import useFetch from "../utils/useFetch";
import {
  IAppSettings,
  setAppOutOfService,
  setAppSettings,
  setOutOfServiceTime,
  toggleWelcomeMessageModal,
} from "../redux/slices/appSlice";
import { useCallback, useEffect } from "react";
import AboutTeam from "../pages/aboutTeam";
import Feedback from "../pages/feedback";
import Gallery from "../pages/gallery";
import Notifications from "../pages/profile/notifications";
import Prompt from "../utils/prompt";
import WelcomeMessageModal from "../components/welcomeMessageModal";
import Help from "../pages/help";
import CompleteSignUp from "../pages/profile/completeSignUp";

declare global {
  interface Window {
    Android: any;
    AudioRecorder: any;
  }
}

const Routes = () => {
  const authenticated = useSelector((store: RootState) => store.user.isLogin);
  const userInfo = useSelector((store: RootState) => store.user.userInfo);
  const dispatch = useDispatch();
  const showWelcomeMessageModal = useSelector(
    (state: RootState) => state.app.showWelcomeMessageModal
  );

  const appSettings = useSelector((state: RootState) => state.app.appSettings);
  const { data: settings } = useFetch<IAppSettings>("v2/setting");

  const caculateShiftsTime = useCallback(() => {
    const firstShiftStartHour = parseInt(
      settings!.shifts.shift_one.start.substring(0, 2)
    );
    const firstShiftStartMin = parseInt(
      settings!.shifts.shift_one.start.substring(3)
    );

    const shiftOneStartDate = new Date().setHours(
      firstShiftStartHour,
      firstShiftStartMin
    );

    const firstShiftEndHour = parseInt(
      settings!.shifts.shift_one.end.substring(0, 2)
    );
    const firstShiftEndMin = parseInt(
      settings!.shifts.shift_one.end.substring(3)
    );

    const shiftOneEndDate = new Date().setHours(
      firstShiftEndHour,
      firstShiftEndMin
    );

    const secondShiftStartHour = parseInt(
      settings!.shifts.shift_two.start.substring(0, 2)
    );
    const secondShiftStartMin = parseInt(
      settings!.shifts.shift_two.start.substring(3)
    );

    const shiftTwoStartDate = new Date().setHours(
      secondShiftStartHour,
      secondShiftStartMin,
      0
    );

    const secondShiftEndHour = parseInt(
      settings!.shifts.shift_two.end.substring(0, 2)
    );
    const secondShiftEndMin = parseInt(
      settings!.shifts.shift_two.end.substring(3)
    );

    const shiftTwoEndDate = new Date().setHours(
      secondShiftEndHour,
      secondShiftEndMin
    );

    return {
      shiftOneStartDate,
      shiftOneEndDate,
      shiftTwoStartDate,
      shiftTwoEndDate,
    };
  }, [settings]);

  useEffect(() => {
    if (settings) {
      dispatch(setAppSettings(settings));
      if (!settings.is_open.isActive) {
        dispatch(setAppOutOfService(true));
      }

      if (!settings.is_open.isInWorkHour) {
        dispatch(setOutOfServiceTime(true));
      }

      // const currentDate = Date.now();

      // const {
      //   shiftOneStartDate,
      //   shiftOneEndDate,
      //   shiftTwoStartDate,
      //   shiftTwoEndDate,
      // } = caculateShiftsTime();

      // if (currentDate < shiftOneStartDate) {
      //   dispatch(setOutOfServiceTime(true));
      // }

      // if (currentDate > shiftOneEndDate && currentDate < shiftTwoStartDate) {
      //   dispatch(setOutOfServiceTime(true));
      // }

      // if (currentDate > shiftTwoEndDate && currentDate < shiftOneStartDate) {
      //   dispatch(setOutOfServiceTime(true));
      // }
    }
  }, [settings, dispatch, caculateShiftsTime]);

  useEffect(() => {
    if (appSettings.welcome_message.length > 0) {
      dispatch(toggleWelcomeMessageModal());
    }
  }, [appSettings.welcome_message, dispatch]);

  const routes = createBrowserRouter([
    {
      path: "/",
      element: <Home />,
    },
    {
      path: "/about",
      element: <About />,
    },
    {
      path: "/help",
      element: <Help />,
    },
    {
      path: "/gallery",
      element: <Gallery />,
    },
    {
      path: "/feedback",
      element: <Feedback />,
    },
    {
      path: "/aboutteam",
      element: <AboutTeam />,
    },
    {
      path: "/contact",
      element: <Contact />,
    },
    {
      path: "/checkout",
      element: <Checkout />,
    },
    {
      path: "/profile",
      element: authenticated ? (
        <Navigate to='/profile/info' />
      ) : (
        <Navigate to='/signin' />
      ),
    },
    {
      path: "/signin",
      element: authenticated ? <Navigate to='/profile/info' /> : <SignIn />,
    },

    {
      path: "/completesignup",
      element:
        userInfo.name !== null ? (
          <Navigate to='/profile/info' />
        ) : (
          <CompleteSignUp />
        ),
    },

    {
      path: "/signup",
      element: authenticated ? <Navigate to='/profile/info' /> : <SignUp />,
    },
    {
      path: "/forgetsubcode",
      element: authenticated ? (
        <Navigate to='/profile/info' />
      ) : (
        <ForgetSubCode />
      ),
    },
    {
      path: "/profile/info",
      element: authenticated ? <ProfileInfo /> : <Navigate to='/signin' />,
    },

    {
      path: "/profile/notifications",
      element: authenticated ? <Notifications /> : <Navigate to='/signin' />,
    },

    {
      path: "/profile/addresses",
      element: authenticated ? <Addresses /> : <Navigate to='/signin' />,
    },
    {
      path: "/profile/wallet",
      element: authenticated ? <Wallet /> : <Navigate to='/signin' />,
    },

    {
      path: "/profile/orders",
      element: <Orders />,
    },
  ]);

  return (
    <>
      <Prompt />
      {showWelcomeMessageModal && <WelcomeMessageModal />}
      <Toaster
        position='bottom-center'
        reverseOrder={false}
        toastOptions={{
          style: {
            fontSize: "1.4em",
          },
        }}
      />
      <RouterProvider router={routes} />
    </>
  );
};

export default Routes;
